/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { PostApiUserManagementV1UsersRefreshParams, ProblemDetails, RefreshAcceptedDto, RefreshRunStatusDto } from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const postApiUserManagementV1UsersRefresh = (
  params?: PostApiUserManagementV1UsersRefreshParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RefreshAcceptedDto>({ url: `/api/user-management/v1/users/refresh`, method: 'POST', params, signal }, options);
};

export const getPostApiUserManagementV1UsersRefreshMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersRefresh>>,
    TError,
    { params?: PostApiUserManagementV1UsersRefreshParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersRefresh>>,
  TError,
  { params?: PostApiUserManagementV1UsersRefreshParams },
  TContext
> => {
  const mutationKey = ['postApiUserManagementV1UsersRefresh'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUserManagementV1UsersRefresh>>,
    { params?: PostApiUserManagementV1UsersRefreshParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiUserManagementV1UsersRefresh(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUserManagementV1UsersRefreshMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersRefresh>>
>;

export type PostApiUserManagementV1UsersRefreshMutationError = ProblemDetails;

export const usePostApiUserManagementV1UsersRefresh = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUserManagementV1UsersRefresh>>,
      TError,
      { params?: PostApiUserManagementV1UsersRefreshParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUserManagementV1UsersRefresh>>,
  TError,
  { params?: PostApiUserManagementV1UsersRefreshParams },
  TContext
> => {
  return useMutation(getPostApiUserManagementV1UsersRefreshMutationOptions(options), queryClient);
};
export const getApiUserManagementV1UsersRefreshCorrelationId = (
  correlationId: string,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RefreshRunStatusDto>(
    { url: `/api/user-management/v1/users/refresh/${correlationId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiUserManagementV1UsersRefreshCorrelationIdQueryKey = (correlationId: string) => {
  return [`/api/user-management/v1/users/refresh/${correlationId}`] as const;
};

export const getGetApiUserManagementV1UsersRefreshCorrelationIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
  TError = ProblemDetails
>(
  correlationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1UsersRefreshCorrelationIdQueryKey(correlationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>> = ({ signal }) =>
    getApiUserManagementV1UsersRefreshCorrelationId(correlationId, requestOptions, signal);

  return { queryKey, queryFn, enabled: correlationId !== null && correlationId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1UsersRefreshCorrelationIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>
>;
export type GetApiUserManagementV1UsersRefreshCorrelationIdQueryError = ProblemDetails;

export function useGetApiUserManagementV1UsersRefreshCorrelationId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
  TError = ProblemDetails
>(
  correlationId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersRefreshCorrelationId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
  TError = ProblemDetails
>(
  correlationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1UsersRefreshCorrelationId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
  TError = ProblemDetails
>(
  correlationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1UsersRefreshCorrelationId<
  TData = Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>,
  TError = ProblemDetails
>(
  correlationId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1UsersRefreshCorrelationId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1UsersRefreshCorrelationIdQueryOptions(correlationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
